const causeMapNodeCompareFn = <
  Node extends { x: number; y: number; width: number; height: number },
>(
  a: Node,
  b: Node
): number => a.y + a.height / 2 - (b.y + b.height / 2);

export default causeMapNodeCompareFn;
